export type DateRange = 'today' | '7d' | '30d' | 'all';

export interface Filters {
  dateRange: DateRange;
  showOpened: boolean;
  showNotOpened: boolean;
}

interface SidebarProps {
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
  stats?: {
    totalOpens: number;
    uniqueEmails: number;
    todayOpens: number;
  };
}

export function Sidebar({ filters, onFiltersChange, stats }: SidebarProps) {
  const handleDateRangeChange = (range: DateRange) => {
    onFiltersChange({ ...filters, dateRange: range });
  };

  const handleStatusChange = (key: 'showOpened' | 'showNotOpened') => {
    onFiltersChange({ ...filters, [key]: !filters[key] });
  };

  return (
    <div className="sidebar-content">
      {stats && (
        <div className="sidebar-section">
          <h3 className="sidebar-title">Quick Stats</h3>
          <div className="mini-stats">
            <div className="mini-stat">
              <span className="mini-stat-value">{stats.totalOpens}</span>
              <span className="mini-stat-label">Total Opens</span>
            </div>
            <div className="mini-stat">
              <span className="mini-stat-value">{stats.uniqueEmails}</span>
              <span className="mini-stat-label">Tracked</span>
            </div>
            <div className="mini-stat">
              <span className="mini-stat-value">{stats.todayOpens}</span>
              <span className="mini-stat-label">Today</span>
            </div>
          </div>
        </div>
      )}

      <div className="sidebar-section">
        <h3 className="sidebar-title">Date Range</h3>
        <div className="filter-options">
          {(['today', '7d', '30d', 'all'] as DateRange[]).map((range) => (
            <label key={range} className="filter-radio">
              <input
                type="radio"
                name="dateRange"
                checked={filters.dateRange === range}
                onChange={() => handleDateRangeChange(range)}
              />
              <span className="filter-radio-label">
                {range === 'today' && 'Today'}
                {range === '7d' && 'Last 7 days'}
                {range === '30d' && 'Last 30 days'}
                {range === 'all' && 'All time'}
              </span>
            </label>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h3 className="sidebar-title">Status</h3>
        <div className="filter-options">
          <label className="filter-checkbox">
            <input
              type="checkbox"
              checked={filters.showOpened}
              onChange={() => handleStatusChange('showOpened')}
            />
            <span className="filter-checkbox-label">Opened</span>
          </label>
          <label className="filter-checkbox">
            <input
              type="checkbox"
              checked={filters.showNotOpened}
              onChange={() => handleStatusChange('showNotOpened')}
            />
            <span className="filter-checkbox-label">Not opened</span>
          </label>
        </div>
      </div>
    </div>
  );
}
